import { render, staticRenderFns } from "./Reject.vue?vue&type=template&id=53c03a4a"
import script from "./Reject.vue?vue&type=script&lang=js"
export * from "./Reject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c03a4a')) {
      api.createRecord('53c03a4a', component.options)
    } else {
      api.reload('53c03a4a', component.options)
    }
    module.hot.accept("./Reject.vue?vue&type=template&id=53c03a4a", function () {
      api.rerender('53c03a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Reject.vue"
export default component.exports